import { resolveByPlatform } from '@i-ark/utils';
import { EnterFullscreenIcon, ExitFullscreenIcon } from '@ui/kit/icons';
import { useFullscreenState } from '@utils/react';
import { useShortcut } from '../hook.use-shortcut.js';
import { Button } from './atom.button.js';
import { useIArkFullscreenActions } from './hooks/useFullscreenActions.js';
import { closeButton } from './tool.fullscreen.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const FullscreenTool = props => {
  const {
    fullscreenSupported,
    fullscreenEnabled
  } = useFullscreenState();
  const {
    handleFullscreenClick,
    handleExitFullscreenClick
  } = useIArkFullscreenActions(props);
  useShortcut("Escape", fullscreenEnabled ? handleExitFullscreenClick : undefined);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [fullscreenSupported && !fullscreenEnabled && /*#__PURE__*/jsx(Button, {
      tooltip: "Åbn fuldskærmsvisning",
      shortcut: resolveByPlatform({
        win: "Ctrl+F",
        mac: "Cmd+F"
      }),
      onClick: handleFullscreenClick,
      children: /*#__PURE__*/jsx(EnterFullscreenIcon, {
        height: 21
      })
    }), fullscreenSupported && fullscreenEnabled && /*#__PURE__*/jsx(Button, {
      className: closeButton,
      tooltip: "Luk fuldskærmsvisning",
      shortcut: resolveByPlatform({
        win: "Ctrl+F",
        mac: "Cmd+F"
      }),
      onClick: handleExitFullscreenClick,
      children: /*#__PURE__*/jsx(ExitFullscreenIcon, {
        height: 21
      })
    })]
  });
};

export { FullscreenTool };
//# sourceMappingURL=tool.fullscreen.js.map
